import React, { ComponentType, LazyExoticComponent } from "react";
import Home from "./Pages/Home/home";
import Landing from "./Pages/Landing/landing";
import Features from "./Pages/Features/Features";
import FAQ from "./Pages/FAQ/faq";
import Pricing from "./Pages/Pricing/pricing";
import TermsCondition from "./Pages/TermsCondition/termsCondtions";
import ShareImage from "./Components/shareImage/ShareImage";
import AddTemplate from "./Pages/AddTemplate/AddTemplate";
import BlogDetails from "./Pages/BlogDetails/blogDetails";
import Blogs from "./Pages/Blogs/blogs";
import RefundPolicy from "./Pages/RefundPolicy/refundPolicy";
import PrivacyPolicy from "./Pages/PrivacyPolicy/privacyPolicy";
import ProfilePage from "./Pages/Profile/ProfilePage";
import BatchWatermark from "./Pages/BatchWatermark/BatchWatermark";
import Maintenance from "./Pages/Maintenance/Maintenance";

// Edit stays lazy: it pulls in Konva (heavy canvas lib) we don't want in the
// initial bundle. It's entered deliberately after an upload, so a brief loader
// there is expected. All other routes are static to avoid per-navigation flicker.
const Edit = React.lazy(() => import("./Pages/Edit/edit"));

export interface RouteConfig {
  path: string;
  component: ComponentType<any> | LazyExoticComponent<ComponentType<any>>;
  exact?: boolean;
}

export const routes: RouteConfig[] = [
  { path: "/", component: Landing, exact: true },
  { path: "/features", component: Features },
  { path: "/pricing", component: Pricing },
  { path: "/faq", component: FAQ },
  { path: "/terms", component: TermsCondition },
  { path: "/refund-policy", component: RefundPolicy },
  { path: "/privacy-policy", component: PrivacyPolicy },
  { path: "/home", component: Home },
  { path: "/batch-watermark", component: BatchWatermark },
  { path: "/addtemplate", component: AddTemplate },
  { path: "/edit", component: Edit },
  { path: "/shareimage", component: ShareImage },
  { path: "/blogs", component: Blogs },
  { path: "/blogs/:slug", component: BlogDetails },
  { path: "/profile", component: ProfilePage },
  { path: "/maintenance", component: Maintenance },
];
